export enum ORGANIZATION_PERMISSION_TYPE {
  // SYSTEM ROLES - Do NOT remove or change these

  OWNER = 'OWNER',
  GUEST = 'GUEST',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',

  // Specific to the app - Add/change roles here for your use case
  // e.g. for eBoard you will have
  MEMBER_MANAGER = 'MEMBER_MANAGER',
  GROUPS_MANAGER = 'GROUPS_MANAGER',
  NEWS_MANAGER = 'NEWS_MANAGER',
  POLL_MANAGER = 'POLL_MANAGER',
  BOARDKIT_MANAGER = 'BOARDKIT_MANAGER',
  ESIGN_MANAGER = 'ESIGN_MANAGER',
  BUSINESS_REPORTS_MANAGER = 'BUSINESS_REPORTS_MANAGER',
  BUSINESS_REPORTS_DOWNLOAD = 'BUSINESS_REPORTS_DOWNLOAD',
  APPROVAL_MANAGER = 'APPROVAL_MANAGER',

  // Member permissions
  MEETING_MANAGER = 'MEETING_MANAGER',
  FOLDER_MANAGER = 'FOLDER_MANAGER',
  DOCUMENT_MANAGER = 'DOCUMENT_MANAGER',
  BUSINESS_REPORTS_READONLY = 'BUSINESS_REPORTS_READONLY',

  //EBM Suite specific permissions
  SALES_ADMIN = 'SALES_ADMIN',
  SALES_READ_ONLY = 'SALES_READ_ONLY',
  SALES_CREATOR_ONLY = 'SALES_CREATOR_ONLY',
  SALES_READ_WRITE_ONLY = 'SALES_READ_WRITE_ONLY',

  INVOICES_ADMIN = 'INVOICES_ADMIN',
  INVOICES_READ_ONLY = 'INVOICES_READ_ONLY',
  INVOICES_CREATOR_ONLY = 'INVOICES_CREATOR_ONLY',
  INVOICES_READ_WRITE_ONLY = 'INVOICES_READ_WRITE_ONLY',

  QUOTES_ADMIN = 'QUOTES_ADMIN',
  QUOTES_READ_ONLY = 'QUOTES_READ_ONLY',
  QUOTES_CREATOR_ONLY = 'QUOTES_CREATOR_ONLY',
  QUOTES_READ_WRITE_ONLY = 'QUOTES_READ_WRITE_ONLY',

  INVENTORY_ADMIN = 'INVENTORY_ADMIN',
  INVENTORY_READ_ONLY = 'INVENTORY_READ_ONLY',
  INVENTORY_CREATOR_ONLY = 'INVENTORY_CREATOR_ONLY',
  INVENTORY_READ_WRITE_ONLY = 'INVENTORY_READ_WRITE_ONLY',

  EXPENSES_ADMIN = 'EXPENSES_ADMIN',
  EXPENSES_READ_ONLY = 'EXPENSES_READ_ONLY',
  EXPENSES_CREATOR_ONLY = 'EXPENSES_CREATOR_ONLY',
  EXPENSES_READ_WRITE_ONLY = 'EXPENSES_READ_WRITE_ONLY',

  KITCHEN_ADMIN = 'KITCHEN_ADMIN',
  KITCHEN_READ_ONLY = 'KITCHEN_READ_ONLY',
  KITCHEN_CREATOR_ONLY = 'KITCHEN_CREATOR_ONLY',
  KITCHEN_READ_WRITE_ONLY = 'KITCHEN_READ_WRITE_ONLY',

  DELIVERY_ADMIN = 'DELIVERY_ADMIN',
  DELIVERY_READ_ONLY = 'DELIVERY_READ_ONLY',
  DELIVERY_CREATOR_ONLY = 'DELIVERY_CREATOR_ONLY',
  DELIVERY_READ_WRITE_ONLY = 'DELIVERY_READ_WRITE_ONLY',

  ASSETS_ADMIN = 'ASSETS_ADMIN',
  ASSETS_READ_ONLY = 'ASSETS_READ_ONLY',
  ASSETS_CREATOR_ONLY = 'ASSETS_CREATOR_ONLY',
  ASSETS_READ_WRITE_ONLY = 'ASSETS_READ_WRITE_ONLY',

  CUSTOMERS_ADMIN = 'CUSTOMERS_ADMIN',
  CUSTOMERS_READ_ONLY = 'CUSTOMERS_READ_ONLY',
  CUSTOMERS_CREATOR_ONLY = 'CUSTOMERS_CREATOR_ONLY',
  CUSTOMERS_READ_WRITE_ONLY = 'CUSTOMERS_READ_WRITE_ONLY',

  VENDORS_ADMIN = 'VENDORS_ADMIN',
  VENDORS_READ_ONLY = 'VENDORS_READ_ONLY',
  VENDORS_CREATOR_ONLY = 'VENDORS_CREATOR_ONLY',
  VENDORS_READ_WRITE_ONLY = 'VENDORS_READ_WRITE_ONLY',

  LEADS_ADMIN = 'LEADS_ADMIN',
  LEADS_READ_ONLY = 'LEADS_READ_ONLY',
  LEADS_CREATOR_ONLY = 'LEADS_CREATOR_ONLY',
  LEADS_READ_WRITE_ONLY = 'LEADS_READ_WRITE_ONLY',

  EMPLOYEES_ADMIN = 'EMPLOYEES_ADMIN',
  EMPLOYEES_READ_ONLY = 'EMPLOYEES_READ_ONLY',
  EMPLOYEES_CREATOR_ONLY = 'EMPLOYEES_CREATOR_ONLY',
  EMPLOYEES_READ_WRITE_ONLY = 'EMPLOYEES_READ_WRITE_ONLY',

  OPPORTUNITY_ADMIN = 'OPPORTUNITY_ADMIN',
  OPPORTUNITY_READ_ONLY = 'OPPORTUNITY_READ_ONLY',
  OPPORTUNITY_CREATOR_ONLY = 'OPPORTUNITY_CREATOR_ONLY',
  OPPORTUNITY_READ_WRITE_ONLY = 'OPPORTUNITY_READ_WRITE_ONLY',

  SALESMANAGER = 'SALESMANAGER',
  INVENTORYMANAGER = 'INVENTORYMANAGER',
  EXPENDITUREMANAGER = 'EXPENDITUREMANAGER',
  ORDERPROCESSOR = 'ORDERPROCESSOR',
  DELIVERY = 'DELIVERY',
  KITCHEN = 'KITCHEN'
}
